import formatPrice from '../helpers/formatPrice';

const PRODUCT_SELECTOR = '.js-product';
const QUANTITY_SELECTOR = '.js-product-quantity';
const PRICE_SELECTOR = '.js-product-price';

const product = {
  initialize() {
    if ($(PRODUCT_SELECTOR).length) {
      this.createEvents();
    }
  },

  createEvents() {
    $(PRODUCT_SELECTOR).on('change', QUANTITY_SELECTOR, ({ currentTarget }) => {
      const $target = $(currentTarget);
      const $price = $target.parents(PRODUCT_SELECTOR).find(PRICE_SELECTOR);
      const calculatedPrice = $target.val() * $price.data('price');

      $price.html(formatPrice(calculatedPrice, 2, ''));
    });
  },
};

export default product;
